import {
  MISSEDCALLS_CONNECTING,
  MISSEDCALLS_DATA,
} from 'store/types';

const INITIALSTATE = {
  timestamp: null,
  loading: null,
  handled: [],
  handled_100rows: [],
  unhandled: [],
  unhandled_30days: [],
  unhandled_10recent: [],
};

export default function (state = INITIALSTATE, action) {
  switch (action.type) {
    case MISSEDCALLS_CONNECTING:
      return {
        ...state,
        timestamp: new Date(),
        loading: true
      };
    case MISSEDCALLS_DATA:
      return {
        ...state,
        timestamp: new Date(),
        loading: false,
        ...action.payload
      };
    default:
      return state;
  }
};
